export const datePickerStrings = {
  placeholder: 'Seleccionar fecha',
} as const

export const timePickerStrings = {
  placeholder: 'Seleccionar hora',
} as const
